import en from './en.json';
import zh from './zh-Hant-TW.json';

export const LOCALES = {
    en: 'en',
    ja: 'ja',
    zh: 'zh',
};

export const handleLocale = (locale: string) => {
    if (locale.startsWith('zh')) {
        return LOCALES.zh;
    }
    return (
        Object.values(LOCALES).find(key => key.startsWith(locale)) ?? LOCALES.en
    );
};

export const intlMessages: Record<string, Record<string, string>> = {
    [LOCALES.en]: en as Record<string, string>,
    [LOCALES.zh]: zh as Record<string, string>,
};
